import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { handleCallback } from "../lib/auth";

export function AuthCallback() {
	const nav = useNavigate();
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		handleCallback().then((res) => {
			if (res.ok) {
				nav(res.returnTo, { replace: true });
			} else {
				setError(res.error);
			}
		});
	}, [nav]);

	if (error) {
		return (
			<div className="p-6">
				<div className="rounded border border-red-300 bg-red-50 p-4 text-sm text-red-800">
					Login failed: <span className="font-mono">{error}</span>
				</div>
				<a href="/" className="mt-3 inline-block text-sm text-blue-700 underline">
					Retry login
				</a>
			</div>
		);
	}
	return <div className="p-6 text-sm text-neutral-600">Signing you in…</div>;
}
